module.exports = __webpack_public_path__ + "static/winlogo-793c0094e1741c51ea2ee439a6930059.jpg";